import { carouselJsClass, initSwiper } from './carousel';
import { disableBodyScroll, enableBodyScroll, trapFocus } from './utils';

const modalClass = 'c-modal';
const modalOpenClass = modalClass + '--open';

const modalJsClass = 'js-modal';
const buttonCloseJsClass = modalJsClass + '-button-close';
const carouselContainerJsClass = modalJsClass + '-carousel-container';

const modalElement = document.querySelector('.' + modalJsClass) as HTMLDialogElement;
const buttonCloseElement = document.querySelector('.' + buttonCloseJsClass) as HTMLButtonElement;
const carouselContainerElement = document.querySelector('.' + carouselContainerJsClass) as HTMLElement;

let requestElement: HTMLElement; // Reference to the element that opened the modal

if (modalElement && buttonCloseElement) {
    // Add a click event listener to the close button
    buttonCloseElement.addEventListener('click', () => {
        closeModal();
    });

    // We add a keydown event listener
    modalElement.addEventListener('keydown', (event) => {
        // If the escape key is pressed
        if (
            event.key === 'Escape'
            && !event.ctrlKey
            && !event.altKey
            && !event.metaKey
            && !event.shiftKey
        ) {
            // We close the modal
            closeModal();
        }
    });
}

export async function openModal (element: HTMLElement, url: string, title: string, initialSlide = 0): Promise<void> {
    if (!element || !url || !title || !modalElement || !buttonCloseElement || !carouselContainerElement) {
        return;
    }

    try {
        // Set request element
        requestElement = element;

        // Fetch carousel markup
        const response = await fetch(url);

        // Get carousel markup from response
        const carouselMarkup = await response.text();

        // Add carousel markup to modal
        carouselContainerElement.innerHTML = carouselMarkup;

        // Get carousel element
        const carouselElement = modalElement.querySelector('.' + carouselJsClass) as HTMLElement;

        // Init Swiper
        initSwiper(carouselElement, initialSlide);

        // Disable body scroll
        disableBodyScroll();

        // Update aria-label
        modalElement.setAttribute('aria-label', title);

        // Open modal
        modalElement.classList.add(modalOpenClass);

        // Set focus on close button
        buttonCloseElement.focus();

        // Trap focus in modal
        trapFocus(modalElement);
    } catch (error) {
        console.error(error);

        // Reset request element
        requestElement = null;
    }
}

export function closeModal (): void {
    if (!modalElement || !carouselContainerElement) {
        return;
    }

    // Enable body scroll
    enableBodyScroll();

    // Update aria-label
    modalElement.setAttribute('aria-label', '');

    // Close modal
    modalElement.classList.remove(modalOpenClass);

    // Remove carousel from modal
    carouselContainerElement.innerHTML = '';

    // Set focus back to element that opened the modal
    requestElement && requestElement.focus();

    // Reset request element
    requestElement = null;
}